// @ts-nocheck
/* eslint-disable */
export const highIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#ED5135" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m2.667 8.667 5.333-2 5.333 2"/></svg>`,
    name: 'high' as const
};